import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInboundCall = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 41,
	height: 40,
	viewBox: "0 0 41 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: .333374,
			width: 40,
			height: 40,
			rx: 20,
			fill: "#F0F3F9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.6642 15.9006L28.3261 11.2387L29.0922 12.0048L24.4303 16.6667L28.5392 16.6667L28.5392 17.75L22.5809 17.75L22.5809 11.7917L23.6642 11.7917L23.6642 15.9006Z",
			fill: "#335CAD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.6664 24.42V27.9561C29.6664 28.4811 29.2605 28.9167 28.7369 28.9537C28.2995 28.9846 27.9427 29 27.6664 29C18.8298 29 11.6664 21.8366 11.6664 13C11.6664 12.7237 11.6818 12.3669 11.7127 11.9295C11.7498 11.4059 12.1853 11 12.7102 11H16.2465C16.5032 11 16.7181 11.1944 16.7439 11.4498C16.7671 11.6791 16.7886 11.8631 16.8085 12.002C17.0107 13.4147 17.4239 14.7594 18.0151 16.003C18.11 16.2026 18.0481 16.4416 17.8682 16.5701L15.7099 18.1118C17.0239 21.1811 19.4853 23.6425 22.5546 24.9565L24.0935 22.8019C24.2236 22.6199 24.4654 22.5573 24.6674 22.6532C25.911 23.2439 27.2555 23.6566 28.668 23.8584C28.806 23.8782 28.9889 23.8995 29.2166 23.9225C29.472 23.9483 29.6664 24.1633 29.6664 24.42Z",
			fill: "#335CAD"
		})
	]
});
const ForwardRef = forwardRef(SvgInboundCall);
export { ForwardRef as ReactComponent };
